<app-data-printer [categories]="categories"></app-data-printer>
